import { render } from "./NewMain.vue?vue&type=template&id=d66ff2bc"
import script from "./NewMain.vue?vue&type=script&lang=js"
export * from "./NewMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__